interface ExclusionDetailsFormDefaultValues {
  exclusionDetails_reason: string | null;
  exclusionDetails_cessationDate: Date | null;
  exclusionDetails_country: number | null;
  exclusionDetails_vatNum: string | null;
}

export function handleExclusionDetailsFormDefaultValues(
  exclusion_details?: any
): ExclusionDetailsFormDefaultValues {
  return {
    exclusionDetails_reason: exclusion_details
      ? `${exclusion_details.exclusion_type_id}`
      : null,
    exclusionDetails_cessationDate: exclusion_details
      ? exclusion_details.cessation_date
      : null,
    exclusionDetails_country: exclusion_details
      ? exclusion_details.msid_member_state_id
      : null,
    exclusionDetails_vatNum: exclusion_details
      ? exclusion_details.msid_vat_num_id
      : null,
  };
}
